export const ACTION_LOAD_CHART_DATA__REQUEST = 'ACTION_LOAD_CHART_DATA__REQUEST';
export const ACTION_LOAD_CHART_DATA__SUCCESS = 'ACTION_LOAD_CHART_DATA__SUCCESS';
export const ACTION_LOAD_CHART_DATA__FAIL = 'ACTION_LOAD_CHART_DATA__FAIL';
